import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import mobilePreview from '@/views/template/frontPageManage/configureManage/mobilePreview';
import { INITAL } from '@/views/template/frontPageManage/configureManage/utils';
import { pageModal } from '../../frontPageManage/configureManage/mobilePreview/components';
export default {
  props: ['templateCongfig'],
  components: {
    mobilePreview,
    pageModal
  },
  data() {
    return {
      src: '',
      list: [],
      //首页
      pageIndex: 0,
      arr: [],
      INITAL,
      pageDescriptionConfig: {},
      pagePopUp: false,
      pagePopUpConfig: {},
      pageModalShow: false,
      disableColor: false,
      homePage: ''
    };
  },
  computed: {
    templateCongfigArr: {
      get() {
        return this.templateCongfig;
      },
      set(val) {
        this.$emit('update:templateCongfig', val);
      }
    }
  },
  watch: {
    templateControlsGroupId: {
      handler() {
        this.list = [];
        this.pageIndex = 0;
        this.getInfoFun();
      },
      deep: true
    }
  },
  mounted() {
    this.getInfoFun();
  },
  methods: {
    getInfoFun() {
      this.templateCongfig.map(item => {
        if (item.isHomePage) {
          this.list.push(item);
          this.homePage = item.controlsGroupPageType;
        }
      });
      this.renderingFun();
      this.dialogVisible = true;
    },
    renderingFun() {
      var _this$list$this$pageI;
      if (this.pageIndex < this.templateCongfigArr.length - 1 && this.templateCongfigArr.length > 1) {
        this.disableColor = false;
      } else {
        this.disableColor = true;
      }
      const controlsGroupConfig = (_this$list$this$pageI = this.list[this.pageIndex]) === null || _this$list$this$pageI === void 0 ? void 0 : _this$list$this$pageI.controlsGroupConfig;
      if (controlsGroupConfig) {
        var _this$list$this$pageI2;
        let arr = [this.INITAL[(_this$list$this$pageI2 = this.list[this.pageIndex]) === null || _this$list$this$pageI2 === void 0 ? void 0 : _this$list$this$pageI2.controlsGroupPageType][0]];
        arr[0].isClick = false;
        arr[0].style = {
          isDisplayNavigation: controlsGroupConfig.isDisplayNavigation,
          titleColor: controlsGroupConfig.isDisplayNavigation,
          backgroundColor: controlsGroupConfig.backgroundColor,
          backgroundImage: controlsGroupConfig.backgroundImage,
          themeColor: controlsGroupConfig.themeColor,
          pageDescription: controlsGroupConfig.pageDescription,
          pageDescriptionConfig: controlsGroupConfig.pageDescriptionConfig,
          pagePopUp: controlsGroupConfig.pagePopUp,
          pagePopUpConfig: controlsGroupConfig.pagePopUpConfig
        };
        this.pageDescription = controlsGroupConfig.pageDescription;
        this.pageDescriptionConfig = controlsGroupConfig.pageDescriptionConfig;
        this.pagePopUp = controlsGroupConfig.pagePopUp;
        this.pagePopUpConfig = controlsGroupConfig.pagePopUpConfig;
        if (this.pagePopUp) {
          this.pageModalShow = true;
        } else {
          this.pageModalShow = false;
        }
        controlsGroupConfig.controlsConfig.map(item => {
          let obj = {
            controlsId: item.controlsId,
            controlsMark: item.controlsMark,
            isClick: false,
            style: item.controlsObject
          };
          arr.push(obj);
        });
        this.arr = arr;
      }
    },
    previousFun() {
      if (this.pageIndex == 0) {
        return false;
      }
      this.arr = [];
      this.pageIndex--;
      this.renderingFun();
    },
    nextFun() {
      // console.log(this.pageIndex, '----------this.pageIndex--------', this.templateCongfig);
      // 过滤信息记录页
      this.templateCongfigArr = this.templateCongfig.filter(ele => ele.controlsGroupPageType !== 'INFORECORD_PAGE');
      if (this.pageIndex < this.templateCongfigArr.length - 1) {
        this.disableColor = false;
        const obj = this.list[this.pageIndex];
        // 退保模版平铺页面(查询记录页底部按钮可不设置)
        if (this.homePage === 'QUERY_INFO_PAGE') {
          if (this.pageIndex + 1 == this.templateCongfigArr.length) {
            return;
          } else {
            this.pageIndex++;
            this.list.push(this.templateCongfigArr[this.pageIndex]);
            this.arr = [];
          }
        } else {
          var _obj$controlsGroupCon, _res$buttonPopUpConfi;
          let res = obj === null || obj === void 0 || (_obj$controlsGroupCon = obj.controlsGroupConfig) === null || _obj$controlsGroupCon === void 0 || (_obj$controlsGroupCon = _obj$controlsGroupCon.controlsConfig) === null || _obj$controlsGroupCon === void 0 || (_obj$controlsGroupCon = _obj$controlsGroupCon[obj.controlsGroupConfig.controlsConfig.length - 1]) === null || _obj$controlsGroupCon === void 0 || (_obj$controlsGroupCon = _obj$controlsGroupCon.controlsObject) === null || _obj$controlsGroupCon === void 0 ? void 0 : _obj$controlsGroupCon.buttonInfo[0];
          const type = (res === null || res === void 0 ? void 0 : res.controlsJump) || (res !== null && res !== void 0 && res.buttonPopUp ? res === null || res === void 0 || (_res$buttonPopUpConfi = res.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == 'jump')) === null || _res$buttonPopUpConfi === void 0 ? void 0 : _res$buttonPopUpConfi.controlsJump : '');
          if (type && type == 'TO_PAY') {
            this.$message.warn(this.$t('下一页为支付页面，暂无预览页面'));
            return false;
          }
          if (type && type == 'TO_SHARE') {
            this.$message.warn(this.$t('下一页为分享页面，暂无预览页面'));
            return false;
          }
          const arr = this.list.findIndex(item => (item === null || item === void 0 ? void 0 : item.controlsGroupPageType) == type);
          console.log(this.pageIndex, '----------else arr--------');
          if (arr < 0 || this.pageIndex + 1 == arr) {
            this.pageIndex++;
            if (this.pageIndex < this.templateCongfigArr.length) {
              this.templateCongfigArr.map(item => {
                if ((item === null || item === void 0 ? void 0 : item.controlsGroupPageType) == type) {
                  this.list.push(item);
                }
              });
              this.arr = [];
            } else {
              return;
            }
          } else {
            return this.$message.error(this.$t('重复页面无法预览，请重新配置'));
          }
        }
        if (this.pageIndex < this.list.length) {
          this.renderingFun();
        }
      }
    }
  }
};